import type { ComponentProps } from 'react';
import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { VisuallyHidden } from '@change-corgi/design-system-legacy/a11y';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

export const RemainingCharacters: React.FC<
	{
		count: number;
	} & ComponentProps<typeof Box>
> = ({ count, ...rest }) => {
	return (
		<Text as="div" sx={{ display: 'flex', justifyContent: 'flex-end' }} {...rest}>
			<VisuallyHidden as="span">
				{/* FIXME the i18n key should not be sap-specific */}
				<Translate
					value="corgi.sap.ai_description.personal_prompt.a11y.remaining_characters"
					replacements={{ numRemainingCharacters: count }}
				/>
			</VisuallyHidden>{' '}
			<Box aria-hidden>{count}</Box>
		</Text>
	);
};
